import { StartupProfileModule } from '../modules/profile';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function StartupProfilePage(): JSX.Element {
  return (
    <StartupSubPageShell activeSection="startup-profile">
      {({ startupId }) => <StartupProfileModule startupId={startupId} />}
    </StartupSubPageShell>
  );
}
